import { styled } from '@mui/material/styles';
//

// ----------------------------------------------------------------------

const Component = styled('div')({
    height: '70px',
    width: '100%',
    backgroundColor: '#f6f7f9',
    alignItems: 'center',
    padding: '16px',
    paddingLeft: '32px',
    display: 'flex',
    borderBottom: '2px solid #b0b3b9'
});

interface IProps {
    children: any;
}
export default function BoxTitlePage(prop: IProps) {
    return (
        <Component>
            {prop.children}
        </Component>
    )
}